export enum wizardTypesEnum {
  roomcontrol = "roomcontrol",
  fireprotection = "fireprotection",
}

export enum Unit {
  de_m3ph = "de_m3ph",
  de_lps = "de_lps",
  de_us = "de_us",
}

export enum productConfiguratorTabsEnum {
  singleSelection = "singleSelection",
  productSuggestion = "productSuggestion",
}
